// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2jlg1","title":"Info_title__2B4aZ","links":"Info_links__3dgcS","link":"Info_link__3N_Da","logo":"Info_logo__1YXzt"};